import React from "react";
import PropTypes from "prop-types";
import styles from "./style.css";
import CarGalleryImageViewer from "../../shared/car-gallery-image-viewer/component";
import Swipeable from "../../shared/swipeable";
import { getCDPAltText } from "../../../utils/helpers/get-cdp-alt-text";

const GalleryMainSlider = ({
    carousalImages,
    updateActiveIndex,
    currentTabIndex,
    tabs,
    imageHost,
    content
}) => {
    const { year, make, model, variant, transmissionType, odometerReading } = content || {};
    const altText = getCDPAltText({ year, make, model, variant, transmissionType, odometerReading });
    const options = {
        enableMouseEvents: true,
        enableArrows: true,
        enableDots: false
    };
    const transformProps = {
        initialScale: 1,
        initialPositionX: 0,
        initialPositionY: 0,
        panning: {
            disabled: false
        }
    };
    return (
        <React.Fragment>
            {Array.isArray(carousalImages) && carousalImages.length && (
                <div styleName={"styles.mainSliderWrap"}>
                    <Swipeable
                        options={options}
                        onChangeIndexCallback={updateActiveIndex}
                        selectedIndex={tabs[currentTabIndex].activeIndex}
                        showSelectedIndex={true}
                    >
                        {
                            carousalImages.map((image, index) => (
                                <div key={index} styleName={"styles.imageWrap"} index={index}>
                                    <CarGalleryImageViewer key={index} basePath={imageHost} selectedImage={image} transformProps={transformProps} styleProp={"spinCarDesktop"} altText={altText} />
                                </div>
                            ))
                        }
                    </Swipeable>
                </div>
            )}
        </React.Fragment>
    );
};

GalleryMainSlider.propTypes = {
    activeTab: PropTypes.string,
    setGsGalleryDataConnect: PropTypes.func,
    content: PropTypes.object,
    imageHost: PropTypes.string,
    selectedImageIndex: PropTypes.number,
    onChangeIndexCallback: PropTypes.func,
    onClickImage: PropTypes.func,
    carousalImages: PropTypes.object,
    updateActiveIndex: PropTypes.number,
    currentTabIndex: PropTypes.number,
    tabs: PropTypes.object
};

export default GalleryMainSlider;
